import m from "mithril";
function toggleBounce() {
  if (marker.getAnimation() !== null) {
    marker.setAnimation(null);
  } else {
    marker.setAnimation(google.maps.Animation.BOUNCE);
  }
}
const MapComponent = {
  
    oncreate: function(vnode){
             
        console.log("init map");
        let mapElement = document.getElementById('map');
        console.log( vnode.attrs.hotel.geoLocation.latitude + " : " + vnode.attrs.hotel.geoLocation.longitude)
        let uluru = {lat: vnode.attrs.hotel.geoLocation.latitude, lng: vnode.attrs.hotel.geoLocation.longitude};
        let map = new google.maps.Map(mapElement, {
            zoom: 17, 
            center: uluru
        });
        let tooltipText = vnode.attrs.hotel.name.en
        let marker = new google.maps.Marker({
            position: uluru,
            animation: google.maps.Animation.DROP,
            title: tooltipText
        });
        marker.setMap(map);
        marker.addListener("click", toggleBounce);
        
    },
    view: function(vnode){
        self = this;
        const {hotel} = vnode.attrs;
        return m("div", {id: "map", class:""})
    }
}

export default MapComponent;